const DEFAULT_PROTOCOL = "https://";

export function normalizeInputUrl(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) {
    throw new Error("URLを入力してください。");
  }

  const withProtocol = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)
    ? trimmed
    : `${DEFAULT_PROTOCOL}${trimmed}`;

  return canonicalizeUrl(withProtocol);
}

export function canonicalizeUrl(input: string, base?: string): string {
  let url: URL;
  try {
    url = base ? new URL(input, base) : new URL(input);
  } catch {
    throw new Error("URLの形式が正しくありません。");
  }

  if (url.protocol !== "http:" && url.protocol !== "https:") {
    throw new Error("http または https のURLを指定してください。");
  }

  url.protocol = url.protocol.toLowerCase();
  url.hostname = url.hostname.toLowerCase();
  url.hash = "";

  if ((url.protocol === "https:" && url.port === "443") || (url.protocol === "http:" && url.port === "80")) {
    url.port = "";
  }

  if (!url.pathname) {
    url.pathname = "/";
  }

  return url.toString();
}

export function tryCanonicalizeUrl(input: string, base?: string): string | null {
  try {
    return canonicalizeUrl(input, base);
  } catch {
    return null;
  }
}

export function isSameOrigin(candidate: string, origin: string): boolean {
  try {
    return new URL(candidate).origin === new URL(origin).origin;
  } catch {
    return false;
  }
}

export function isFetchableHref(href: string): boolean {
  const trimmed = href.trim().toLowerCase();
  return Boolean(trimmed) && !trimmed.startsWith("mailto:") && !trimmed.startsWith("tel:") && !trimmed.startsWith("javascript:");
}

export function getOrigin(input: string): string {
  return new URL(input).origin;
}

export function safeHostname(input: string): string {
  try {
    return new URL(input).hostname;
  } catch {
    return "";
  }
}
